<template>
    <div class="echart" :id="id"></div>
</template>
<script>
export default {
    name:'homePieChart',
    data(){
         return {
            chart:''
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        },
        jump:{
            type:String,
            default:function(){
                return '';
            }
        },
        legName:{
            type:String,
            default:function(){
                return '平台分布';
            }
        },
        colorArr:{
            type: Array,
            default: function () {
                return [['#02b555','#00de78'],['#f39719','#f17d10'],['#00bcea','#009cde'],['#ef3660','#df133f'],['#4960fd','#3a2acd'],['#7f0ad6','#6900c4'],['#1ac7b0','#1390a0'],['#a8d123','#90a913'],['#02b555','#00de78'],['#f39719','#f17d10'],['#00bcea','#009cde'],['#ef3660','#df133f'],['#4960fd','#3a2acd'],['#7f0ad6','#6900c4'],['#1ac7b0','#1390a0'],['#a8d123','#90a913']]

            }
        }
    },
    mounted() {
        const that = this
        that.$nextTick(()=> {
            that.init();
        })
    },
    watch: {
        'dataArray': function (n, o) {
            this.init();
        }
    },
    methods: {
        setColor(){
            let colArr=[];
            this.colorArr.forEach(ele => {
                let tempColr =  new this.$echarts.graphic.LinearGradient(0, 0, 0, 1,
                    [
                        {offset: 0, color:ele[0] },
                        {offset: 1, color:ele[1]  }
                    ]
                );
                colArr.push(tempColr);

            });
           
            //var colr = ;
            return colArr;
        },
        pieOption(){
            let _this = this;
            var option = {
                title: {
                    text: _this.legName,
                    top:'center',
                    left:'center',
                    textStyle: {
                        color: '#fff',
                        fontSize:22
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{b}: {c} ({d}%)",
                },
                color:_this.setColor(),
                tooltip: {
                    trigger: 'item',
                    formatter: "{b}: {c} ({d}%)",
                },
                series: [{
                        name:'',
                        type: 'pie',
                        startAngle:330,
                        radius: ['46%', '70%'],
                        label: {
                            normal: {
                                formatter: "{b} {d}%",
                                textStyle: {
                                   // color:['#00de78','#f17d10','#f39719'],
                                    fontSize:14
                                },
                            },
                        },
                        itemStyle: {
                            normal: {
                                label: {
                                    show: true,
                                    formatter : function (params) {                         
                                        return (params.percent - 0).toFixed(2) + '%'
                                    },
                                },
                                borderWidth:3,
                                borderColor:'#15152f',
                            }
                        },
                        data:_this.getData()
                    }
                ]
            }
            return option;
        },
        getData(){
            let _this = this,newData=[];
            _this.dataArray.forEach((ele,index)=>{
                ele.label= {
                    normal: {
                        color:_this.colorArr[index][0],
                    }
                }
                newData.push(ele);
            })
            return newData;
        },
        
        init(){
            let _this = this;
            _this.$echarts.init(document.getElementById(_this.id)).dispose();
            _this.chart = _this.$echarts.init(document.getElementById(_this.id));
            _this.chart.setOption(_this.pieOption());
            _this.chart.on('click', function (param) {
                // console.log(param);
                let type = _this.jump;
                let platformType = '';
                let emotion = '';
                if(type != ''){//不为空需要跳转
                    if(type === 'platformType'){//平台
                        platformType = param.data.index;
                    }
                    if(type === 'emotion'){//平台
                        emotion = param.name;
                    }
                    let query = {
                        platformType:platformType,
                        emotion:emotion,
                        dayType:6
                    }
                    let routeData = _this.$router.resolve({ path:'/analysis/informationSet',query:query});
                    window.open(routeData.href, '_blank');
                }
                
            });
            window.addEventListener("resize",function(){
                _this.chart.resize(); 
            });
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>


// WEBPACK FOOTER //
// src/components/echart/homePieChart.vue